import { useContext } from 'react';
import { SchedulesApiContext } from './SchedulesApiContext';
import type { SchedulesApiClient } from './types';

export function useSchedulesApiClient(): SchedulesApiClient {
  const client = useContext(SchedulesApiContext);
  if (client === null) {
    throw new Error(
      'useSchedulesApiClient: no SchedulesApiProvider in the tree. ' +
        'Wrap the consumer in <SchedulesApiProvider client={...}>.',
    );
  }
  return client;
}
